import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LocalStorage } from 'lib/storage'

/**
 * Settings
 *
 * Should be a slice where we put all settings that aren't synced with server (E.g. Local storage saved ones)
 *
 * TODO: Migrate Timeline slice into this one
 */

const defaultValue = {
  groups: {
    hideRepliesOnTimeline: false,
  },
  activities: {
    singleFeed: false,
  },
}

const initialState = LocalStorage.settings.get(defaultValue)

type State = typeof initialState

const setter =
  <K extends keyof State>(settingKey: K) =>
  <KI extends keyof State[K]>(
    state: State,
    action: PayloadAction<{ key: KI; value: State[K][KI] }>
  ) => {
    if (!state[settingKey]) state[settingKey] = {}
    state[settingKey][action.payload.key] = action.payload.value
    LocalStorage.settings.set(state)
  }

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettingsForGroups: setter('groups'),
    setSettingsForActivities: setter('activities'),
  },
})

const selectSelf = (state): State => state.settings
export const selectSettingsForGroups = createSelector(
  selectSelf,
  (state) => state.groups ?? defaultValue.groups
)

export const selectSettingsForActivities = createSelector(
  selectSelf,
  (state) => state.activities ?? defaultValue.activities
)

export const { setSettingsForGroups, setSettingsForActivities } =
  settingsSlice.actions

export default settingsSlice.reducer
